export default __webpack_public_path__ + "static/media/picto-scan.700fae3d.png";